import { css } from 'styled-components';
import { pxToRem } from '@fil-react-mixins/styled';
export default css(["background-color:", ";width:", ";max-height:", ";margin-top:", ";padding-top:", ";padding-bottom:", ";position:relative;.toast{&__status{padding:", " ", ";font-size:", ";&--success{color:", ";}&--warning{color:", ";}&--error{color:", ";}&--info{color:", ";}&--loading{line-height:1.5;}}&__text,&__title{color:", ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}&__title{font-weight:", ";margin:", ";}&__close{font-size:", ";color:", ";cursor:pointer;}}"], function (props) {
  return props.theme.color.base.grey['700'].value;
}, pxToRem(350), pxToRem(96), pxToRem(20), pxToRem(20), pxToRem(20), pxToRem(0), pxToRem(16), pxToRem(24), function (props) {
  return props.theme.input.validColor;
}, function (props) {
  return props.theme.input.warningDarkColor;
}, function (props) {
  return props.theme.input.invalidColor;
}, function (props) {
  return props.theme.input.infoColor;
}, function (props) {
  return props.theme.color.base.grey['025'].value;
}, function (props) {
  return props.theme.typography.fontWeightBold;
}, pxToRem(0), pxToRem(14), function (props) {
  return props.theme.color.base.grey['025'].value;
});